import { App } from 'vue';

import MiniCart from '@/components/Cart/MiniCart/MiniCart.vue';
import { useCartStore } from '@/shared/pinia/modules/cart';

import type { InitializationState } from './index';
import { miniCartMountSelector } from './index';
import { initializeComponent } from './shared';

export const initMiniCart = async (
  waitForCartUpdate = false,
  mountedApps: Map<string, App>,
  initializationState: InitializationState
): Promise<void> => {
  await initializeComponent({
    containerId: 'mini-cart',
    mountSelector: miniCartMountSelector,
    component: MiniCart,
    state: initializationState.miniCart,
    mountedApps,
    waitForCartUpdate,
    extractProps: (container) => {
      const dataset = container.dataset;
      return {
        shippingThreshold: Number(dataset.shippingThreshold || 0),
        lowestShippingPrice: Number(dataset.lowestShippingPrice || 0),
        showSalesTaxMessage: dataset.showSalesTaxMessage === 'true',
        giftThreshold: Number(dataset.giftThreshold || 0),
        scenario: (dataset.scenario || 'none') as
          'none' | 'shipping_only' | 'dual_threshold',
        initialShowThreshold: Number(dataset.initialShowThreshold || 0),
        giftCollectionHandle: dataset.giftCollectionHandle || 'reward-products',
        crossSellCollectionHandle: dataset.crossSellCollectionHandle || 'yarn'
      };
    },
    onBeforeMount: (props) => {
      if (props.giftThreshold > 0) {
        useCartStore().setGiftThreshold(props.giftThreshold);
      }
    }
  });
};
